export default __webpack_public_path__ + "static/media/VGSTV.1bb8697a.png";